'use client';
import { jsx } from 'react/jsx-runtime';
import { getCSSVar } from '@chakra-ui/styled-system';
import { motion } from 'framer-motion';
import { useTooltipStyles, useTooltipContext } from './tooltip-context.mjs';
import { scale } from './tooltip-transition.mjs';
import { useTheme } from '../system/use-theme.mjs';
import { cssVars } from '../popper/utils.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const TooltipContent = forwardRef(
  function TooltipContent2(props, ref) {
    const styles = useTooltipStyles();
    const api = useTooltipContext();
    const theme = useTheme();
    const {
      bg,
      motionProps,
      background,
      backgroundColor,
      bgColor,
      ...restProps
    } = props;
    const _bg = background ?? backgroundColor ?? bg ?? bgColor;
    if (_bg) {
      styles.bg = _bg;
      const bgVar = getCSSVar(theme, "colors", _bg);
      styles[cssVars.arrowBg.var] = bgVar;
    }
    return /* @__PURE__ */ jsx(
      chakra.div,
      {
        asChild: true,
        __css: styles,
        ...api.getContentProps(restProps, ref),
        children: /* @__PURE__ */ jsx(
          motion.div,
          {
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...motionProps,
            children: props.children
          }
        )
      }
    );
  }
);
TooltipContent.displayName = "TooltipContent";

export { TooltipContent };
